import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { SECTIONS } from '@/constants/routes.constants';

export function useActiveSection(): string | undefined {
	const { pathname } = useLocation();
	const bases = useMemo(() => Object.values(SECTIONS).sort((a, b) => b.length - a.length), []);

	return useMemo(() => {
		if (pathname === '/' || pathname === '') return undefined;
		return bases.find((base) => pathname === base || pathname.startsWith(base + '/'));
	}, [pathname, bases]);
}
